import { render, staticRenderFns } from "./WechatUserManage.vue?vue&type=template&id=6bf54b1e&scoped=true"
import script from "./WechatUserManage.vue?vue&type=script&lang=js"
export * from "./WechatUserManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf54b1e",
  null
  
)

export default component.exports